export default __webpack_public_path__ + "svg/CompaniesLogos/logo_product-hackers.svg?3b4f8e24";